import { Box, Button, Stack, Typography } from "@mui/material";
import { useMemo } from "react";

import images from "../constants/images";
import { getResourceGatheringIconResourcesTypes } from "../utils/getResourceGatheringIcon";
import type { LabTypes } from "./Lab";
import EXPBlock from "./ui/EXPBlock";

interface TypesProps {
  title: string;
  cards: LabTypes[];
}

const LabTabs = ({ title, cards }: TypesProps) => {
  const unlock = useMemo(() => {
    return cards.every((card) => card.value >= card.maxValue);
  }, [cards]);

  return (
    <Stack
      border={"2px solid"}
      borderRadius={"24px"}
      bgcolor={"secondary.bgTabsQuests"}
      borderColor={"secondary.borderTabsQuests"}
    >
      <Stack
        height={"32px"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        borderRadius={"24px 24px 0 0"}
        bgcolor={"secondary.headerTabsQuests"}
        boxShadow={"0px 4px 4px rgba(0, 0, 0, 0.1)"}
      >
        <Typography color="primary.textBlueColor" fontSize={"18px"}>
          {title}
        </Typography>
      </Stack>
      <Stack p={1} gap={1}>
        {cards.map((card) => (
          <Stack
            gap={2}
            px={1}
            key={card.id}
            width={"100%"}
            height={"62px"}
            display={"flex"}
            direction={"row"}
            border={"2px solid"}
            borderRadius={"16px"}
            alignItems={"center"}
            justifyContent={"space-between"}
            bgcolor={
              card.value >= card.maxValue
                ? "primary.lightYellow"
                : "secondary.bgCardQuest"
            }
            borderColor={
              card.value >= card.maxValue
                ? "primary.yellowBorder"
                : "secondary.borderCardQuest"
            }
          >
            <Stack
              gap={1}
              width={"100%"}
              direction={"row"}
              alignItems={"center"}
            >
              <Box
                height={"45px"}
                width={"55px"}
                position={"relative"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{
                  backgroundImage: `url(${images.lab.bg})`,
                  backgroundSize: "cover",
                }}
              >
                <img
                  style={{ width: "33px", height: "33px" }}
                  src={getResourceGatheringIconResourcesTypes(card.type) || ""}
                  alt={card.title}
                />
              </Box>
              <Stack direction={"column"} width={"100%"} mb={0.5}>
                <Typography
                  noWrap
                  fontSize={"14px"}
                  color="primary.textResearchLab"
                >
                  {card.title}
                </Typography>
                <EXPBlock value={card.value} maxValue={card.maxValue} />
              </Stack>
            </Stack>
          </Stack>
        ))}
      </Stack>
      <Stack
        p={1}
        display={"flex"}
        alignItems={"center"}
        height={"fit-content"}
        justifyContent={"center"}
        bgcolor={"secondary.dark"}
        borderRadius={"0 0 24px 24px "}
      >
        <Button
          disabled={!unlock}
          variant="blue"
          sx={{ width: "100%", boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.3)" }}
        >
          Unlock
        </Button>
      </Stack>
    </Stack>
  );
};

export default LabTabs;
